import {Component} from '@angular/core';
import {
  StudiefinancieringAangeverComponent
} from './studiefinanciering/studiefinanciering-aangever/studiefinanciering-aangever.component';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-pga-scholingsuitgaven',
  templateUrl: './pga-scholingsuitgaven.component.html',
  styleUrls: ['./pga-scholingsuitgaven.component.scss'],
  imports: [
    StudiefinancieringAangeverComponent
  ]
})
export class PgaScholingsuitgavenComponent {
}
